
export class RetrievePasswordHistoryRequest {
    fullHistory: boolean;
}